/*
 * MedSkin Studios - automatic free gift (Medik8 Vanity Case)
 *
 * Adds the gift to the cart when qualifying items reach the threshold, removes it
 * again if the cart drops below it, and keeps the progress message in sync.
 * Shopify's automatic BXGY discount makes the gift 100% off; this script only
 * adds / removes the line. Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  if (window.__medskinFreeGift) return;
  window.__medskinFreeGift = true;

  var CFG = {
    variantId: 58433873477980,
    threshold: 8500, // pence
    property: '_auto_gift',
    currency: 'GBP',
    debounceMs: 300,
    declinedKey: 'medskin_gift_declined', // customer removed the gift this session
    seenKey: 'medskin_gift_seen', // '1' when the last cart read contained the auto gift
    noDiscountKey: 'medskin_gift_nodiscount', // qualifying subtotal at which the discount failed to apply
    reloadKey: 'medskin_gift_reload_ts'
  };

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var busy = false;
  var again = false;
  var timer = null;
  var outOfStock = false;

  /* ---------- helpers ---------- */

  function store(key, value) {
    try {
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, String(value));
    } catch (e) {}
  }

  function load(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function route(name, fallback) {
    var r = window.routes && window.routes[name];
    return (r || fallback).replace(/\/$/, '');
  }

  function isCartMutation(url) {
    try {
      var path = new URL(String(url), window.location.href).pathname;
      return /(?:^|\/)cart\/(?:add|change|update|clear)(?:\.js|\.json)?\/?$/.test(path);
    } catch (e) {
      return false;
    }
  }

  function isCartPage() {
    return (
      (window.theme && window.theme.cartpage === true) ||
      /(?:^|\/)cart\/?$/.test(window.location.pathname)
    );
  }

  function request(url, options) {
    if (!nativeFetch) return Promise.reject(new Error('fetch unavailable'));
    options = options || {};
    options.credentials = 'same-origin';
    return nativeFetch(url, options).then(function (res) {
      return res.json().then(
        function (json) {
          if (!res.ok) {
            var err = new Error((json && (json.description || json.message)) || 'HTTP ' + res.status);
            err.status = res.status;
            throw err;
          }
          return json;
        },
        function () {
          var err = new Error('Invalid response');
          err.status = res.status;
          throw err;
        }
      );
    });
  }

  function post(url, body) {
    return request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function readCart() {
    return request(route('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
  }

  function formatMoney(cents, format) {
    format = format || '£{{amount}}';
    function digits(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount_no_decimals':
          return digits(cents, 0);
        case 'amount_with_comma_separator':
          return digits(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return digits(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return digits(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return digits(cents, 0, ' ');
        case 'amount_with_space_separator':
          return digits(cents, 2, ' ', ',');
        default:
          return digits(cents, 2);
      }
    });
  }

  /* ---------- cart analysis ---------- */

  function analyse(cart) {
    var qualifying = 0;
    var auto = null;
    var manualFree = false;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (Number(item.variant_id) !== CFG.variantId) {
        qualifying += Number(item.original_line_price) || 0;
        continue;
      }
      var props = item.properties || {};
      if (props[CFG.property]) {
        if (!auto) auto = item;
      } else if (Number(item.final_line_price) < Number(item.original_line_price)) {
        // a Vanity Case the customer added themselves is already free via the discount
        manualFree = true;
      }
    }
    return {
      qualifying: qualifying,
      qualifies: qualifying >= CFG.threshold,
      auto: auto,
      manualFree: manualFree
    };
  }

  /* ---------- progress message ---------- */

  function render(cart) {
    var els = document.querySelectorAll('[data-msg-gift]');
    if (!els.length) return;
    var a = analyse(cart);
    var inCart = !!(a.auto && Number(a.auto.final_line_price) === 0) || a.manualFree;
    var state;
    if (!a.qualifies) state = 'progress';
    else if (inCart) state = 'added';
    else if (outOfStock) state = 'oos';
    else state = 'unlocked';

    var pct = Math.max(0, Math.min(100, Math.floor((a.qualifying * 100) / CFG.threshold)));
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var text = el.getAttribute('data-text-' + state) || '';
      if (state === 'progress') {
        text = text.replace(
          '{amount}',
          formatMoney(CFG.threshold - a.qualifying, el.getAttribute('data-money-format'))
        );
      }
      var textEl = el.querySelector('.msg-gift__text');
      if (textEl) textEl.innerHTML = text;
      var bar = el.querySelector('.msg-gift__bar');
      var fill = el.querySelector('.msg-gift__fill');
      if (fill) fill.style.width = pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(pct));
      el.setAttribute('data-qualifying', String(a.qualifying));
      el.setAttribute('data-state', state);
    }
  }

  /* ---------- refresh what the shopper sees ---------- */

  function refreshTheme(cart, changed) {
    // 1. progress message (always)
    render(cart);
    if (!changed) return;

    // 2. this theme's JS-rendered mini cart / drawer (jQuery based, not Dawn section rendering)
    var t = window.theme;
    try {
      if (t && t.miniCart) {
        if (t.miniCart.updateElements) t.miniCart.updateElements();
        if (t.miniCart.generateCart) t.miniCart.generateCart();
      } else {
        var counts = document.querySelectorAll('.js-cart-count');
        for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
      }
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('medskin:gift-updated', { detail: { cart: cart } }));
    } catch (e) {}

    // 3. the cart page is server rendered: reload it, but never more than once every few seconds
    if (isCartPage()) {
      var last = Number(load(CFG.reloadKey)) || 0;
      if (Date.now() - last > 4000) {
        store(CFG.reloadKey, Date.now());
        window.location.reload();
      }
    }
  }

  /* ---------- core logic ---------- */

  function removeLine(line) {
    return post(route('cart_change_url', '/cart/change') + '.js', { id: line.key, quantity: 0 });
  }

  function evaluate(cart) {
    if (!cart.item_count) {
      store(CFG.declinedKey, null);
      store(CFG.seenKey, null);
      store(CFG.noDiscountKey, null);
      outOfStock = false;
      return Promise.resolve({ cart: cart, changed: false });
    }
    if (cart.currency && cart.currency !== CFG.currency) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    var a = analyse(cart);
    var declined = load(CFG.declinedKey) === '1';

    // The gift was in the cart on the last read, the cart still qualifies and it is gone now:
    // the customer removed it. Remember that so we do not add it back in a loop.
    if (a.qualifies && !a.auto && load(CFG.seenKey) === '1' && !declined) {
      store(CFG.declinedKey, '1');
      declined = true;
    }

    // --- auto gift line present ---
    if (a.auto) {
      if (!a.qualifies) {
        store(CFG.seenKey, '0');
        return removeLine(a.auto).then(finish(true), function () {
          return { cart: cart, changed: false };
        });
      }
      if (Number(a.auto.quantity) > 1) {
        // only one gift is free: never leave a chargeable extra on the gift line
        return post(route('cart_change_url', '/cart/change') + '.js', { id: a.auto.key, quantity: 1 }).then(
          finish(true),
          function () {
            return { cart: cart, changed: false };
          }
        );
      }
      if (Number(a.auto.final_line_price) > 0) {
        // discount did not apply: do not let anyone pay for a "free" gift
        store(CFG.noDiscountKey, a.qualifying);
        store(CFG.seenKey, '0');
        return removeLine(a.auto).then(finish(true), function () {
          return { cart: cart, changed: false };
        });
      }
      store(CFG.seenKey, '1');
      outOfStock = false;
      return Promise.resolve({ cart: cart, changed: false });
    }

    // --- no auto gift line ---
    store(CFG.seenKey, '0');
    var failedAt = load(CFG.noDiscountKey);
    var blocked = declined || a.manualFree || (failedAt !== null && Number(failedAt) === a.qualifying);
    if (!a.qualifies || blocked) {
      if (!a.qualifies) store(CFG.noDiscountKey, null);
      return Promise.resolve({ cart: cart, changed: false });
    }

    var item = { id: CFG.variantId, quantity: 1, properties: {} };
    item.properties[CFG.property] = '1';
    return post(route('cart_add_url', '/cart/add') + '.js', { items: [item] }).then(
      function () {
        outOfStock = false;
        return readCart().then(function (after) {
          var b = analyse(after);
          if (b.auto && Number(b.auto.final_line_price) > 0) {
            store(CFG.noDiscountKey, b.qualifying);
            return removeLine(b.auto).then(
              function () {
                return readCart().then(function (final) {
                  return { cart: final, changed: false };
                });
              },
              function () {
                return { cart: after, changed: true };
              }
            );
          }
          store(CFG.seenKey, b.auto ? '1' : '0');
          return { cart: after, changed: true };
        });
      },
      function () {
        // e.g. out of stock: do nothing further, tell the customer
        outOfStock = true;
        return { cart: cart, changed: false };
      }
    );
  }

  // after a successful change request, re-read the cart for the final state
  function finish(changed) {
    return function () {
      return readCart().then(function (final) {
        return { cart: final, changed: changed };
      });
    };
  }

  function run() {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    readCart()
      .then(evaluate)
      .then(function (result) {
        refreshTheme(result.cart, result.changed);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, CFG.debounceMs);
  }

  /* ---------- triggers ---------- */

  // fetch() based cart calls
  if (nativeFetch) {
    window.fetch = function (input) {
      var promise = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && isCartMutation(url)) {
          promise.then(
            function (res) {
              if (res && res.ok) schedule();
            },
            function () {}
          );
        }
      } catch (e) {}
      return promise;
    };
  }

  // XMLHttpRequest / jQuery.ajax based cart calls (this theme uses these)
  if (window.XMLHttpRequest) {
    var xhrProto = window.XMLHttpRequest.prototype;
    var origOpen = xhrProto.open;
    var origSend = xhrProto.send;
    xhrProto.open = function (method, url) {
      try {
        this.__medskinCart = isCartMutation(url);
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    xhrProto.send = function () {
      if (this.__medskinCart) {
        var xhr = this;
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) schedule();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // theme / generic cart events (harmless if the theme never fires them)
  ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added', 'cart:requestComplete'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (!busy) schedule();
    });
  });

  // "Add it" link shown if the customer previously removed the gift
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-msg-gift-add]')) {
      event.preventDefault();
      store(CFG.declinedKey, null);
      store(CFG.noDiscountKey, null);
      outOfStock = false;
      schedule();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) schedule();
  });

  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.MedSkinFreeGift = { run: schedule, config: CFG };
})();
